// src/data/languages/lingala/categories/sentencesgap.ts

import { RevisionSentenceCollection } from '../../../../types/types';



// Collection de phrases pour la révision en lingala
export const sentencesgap: RevisionSentenceCollection = {
  // Phrases existantes
  "na": [
    { original: "Nazali na ndako", french: "Je suis à la maison", english: "I am at home" },
    { original: "Yaka na ngai", french: "Viens avec moi", english: "Come with me" },
    { original: "Toza na mboka", french: "Nous sommes au village", english: "We are in the village" },
    { original: "Bilei na mesa", french: "La nourriture est sur la table", english: "The food is on the table" },
    { original: "Ye azali na mbongo", french: "Il a de l'argent", english: "He has money" }
  ],
  "nkombo": [
    { original: "Nkombo na ngai ezali", french: "Mon nom est", english: "My name is" },
    { original: "Nkombo na ye ezali nini?", french: "Quel est son nom?", english: "What is his/her name?" },
    { original: "Soki nkombo na yo nani?", french: "Comment t'appelles-tu?", english: "What is your name?" }
  ],
  "ezali": [
    { original: "Ye ezali malamu", french: "Il/Elle va bien", english: "He/She is doing well" },
    { original: "Sanza ezali na mwinda", french: "La lune brille", english: "The moon is shining" },
    { original: "Mbala ezali kitoko", french: "L'orange est belle", english: "The orange is beautiful" }
  ],

  "nazali": [
    { original: "Nazali na ndako", french: "Je suis à la maison", english: "I am at home" },
    { original: "Nazali malamu", french: "Je vais bien", english: "I am doing well" },
    { original: "Nazali koliya", french: "Je suis en train de manger", english: "I am eating" }
  ],
  "ozali": [
    { original: "Ozali wapi?", french: "Où es-tu?", english: "Where are you?" },
    { original: "Ozali malamu", french: "Tu vas bien", english: "You are doing well" },
    { original: "Ozali koloba", french: "Tu es en train de parler", english: "You are speaking" }
  ],
  "azali": [
    { original: "Azali awa", french: "Il/Elle est ici", english: "He/She is here" },
    { original: "Azali kosala", french: "Il/Elle est en train de travailler", english: "He/She is working" },
    { original: "Azali malamu", french: "Il/Elle va bien", english: "He/She is doing well" }
  ],
  "tozali": [
    { original: "Tozali na mosala", french: "Nous sommes au travail", english: "We are at work" },
    { original: "Tozali koyekola", french: "Nous sommes en train d'étudier", english: "We are studying" },
    { original: "Tozali na esengo", french: "Nous sommes heureux", english: "We are happy" }
  ],
  "bozali": [
    { original: "Bozali malamu?", french: "Vous allez bien?", english: "Are you doing well?" },
    { original: "Bozali wapi?", french: "Où êtes-vous?", english: "Where are you?" },
    { original: "Bozali kolala", french: "Vous êtes en train de dormir", english: "You are sleeping" }
  ],
  "bazali": [
    { original: "Bazali na bokebi", french: "Ils sont attentifs", english: "They are attentive" },
    { original: "Bazali kosana", french: "Ils sont en train de jouer", english: "They are playing" },
    { original: "Bazali malamu", french: "Ils vont bien", english: "They are doing well" }
  ],
  "nazali_na": [
    { original: "Nazali na mbongo", french: "J'ai de l'argent", english: "I have money" },
    { original: "Nazali na ndako", french: "J'ai une maison", english: "I have a house" },
    { original: "Nazali na bilei", french: "J'ai de la nourriture", english: "I have food" }
  ],

  // Conjugaison passé
  "nazalaki": [
    { original: "Nazalaki na mboka", french: "J'étais au village", english: "I was in the village" },
    { original: "Nazalaki awa", french: "J'étais ici", english: "I was here" },
    { original: "Nazalaki kosala", french: "J'étais en train de travailler", english: "I was working" }
  ],
  "ozalaki": [
    { original: "Ozalaki awa", french: "Tu étais ici", english: "You were here" },
    { original: "Ozalaki wapi?", french: "Où étais-tu?", english: "Where were you?" },
    { original: "Ozalaki koliya", french: "Tu étais en train de manger", english: "You were eating" }
  ],
  "azalaki": [
    { original: "Azalaki awa", french: "Il/Elle était ici", english: "He/She was here" },
    { original: "Azalaki na esengo", french: "Il/Elle était heureux", english: "He/She was happy" },
    { original: "Azalaki kosala", french: "Il/Elle était en train de travailler", english: "He/She was working" }
  ],
  "tozalaki": [
    { original: "Tozalaki elongo", french: "Nous étions ensemble", english: "We were together" },
    { original: "Tozalaki koyekola", french: "Nous étions en train d'étudier", english: "We were studying" },
    { original: "Tozalaki na mosala", french: "Nous étions au travail", english: "We were at work" }
  ],
  "bozalaki": [
    { original: "Bozalaki wapi?", french: "Où étiez-vous?", english: "Where were you?" },
    { original: "Bozalaki elongo", french: "Vous étiez ensemble", english: "You were together" },
    { original: "Bozalaki kolala", french: "Vous étiez en train de dormir", english: "You were sleeping" }
  ],
  "bazalaki": [
    { original: "Bazalaki na esengo", french: "Ils étaient heureux", english: "They were happy" },
    { original: "Bazalaki na ndako", french: "Ils étaient à la maison", english: "They were at home" },
    { original: "Bazalaki kosana", french: "Ils étaient en train de jouer", english: "They were playing" }
  ],

  // Pronoms sujets
  "ngai": [
    { original: "Ngai nazali koliya", french: "Je suis en train de manger", english: "I am eating" },
    { original: "Libota na ngai ezali monene", french: "Ma famille est grande", english: "My family is big" },
    { original: "Mama na ngai azali mosali", french: "Ma mère est travailleuse", english: "My mother is hardworking" }
  ],
  "yo": [
    { original: "Yo ozali koloba", french: "Tu es en train de parler", english: "You are speaking" },
    { original: "Yo ozali wapi?", french: "Où es-tu?", english: "Where are you?" },
    { original: "Ndako ya yo ezali malamu", french: "Ta maison est belle", english: "Your house is beautiful" }
  ],
  "ye": [
    { original: "Ye azali kosala", french: "Il/Elle est en train de travailler", english: "He/She is working" },
    { original: "Ye azali na bilei", french: "Il/Elle a de la nourriture", english: "He/She has food" },
    { original: "Moninga na ye azali awa", french: "Son ami est ici", english: "His/Her friend is here" }
  ],
  "biso": [
    { original: "Biso tozali koyekola", french: "Nous sommes en train d'étudier", english: "We are studying" },
    { original: "Mboka na biso ezali monene", french: "Notre village est grand", english: "Our village is big" },
    { original: "Biso tozali na esengo", french: "Nous sommes heureux", english: "We are happy" }
  ],
  "bino": [
    { original: "Bino bozali kolala", french: "Vous êtes en train de dormir", english: "You are sleeping" },
    { original: "Bino bozali wapi?", french: "Où êtes-vous?", english: "Where are you?" },
    { original: "Bilei na bino ezali wapi?", french: "Où est votre nourriture?", english: "Where is your food?" }
  ],
  "bango": [
    { original: "Bango bazali kosana", french: "Ils/Elles sont en train de jouer", english: "They are playing" },
    { original: "Bango bazali na ndako", french: "Ils/Elles ont une maison", english: "They have a house" },
    { original: "Mbongo na bango ezali mingi", french: "Leur argent est beaucoup", english: "They have a lot of money" }
  ],

  // Prépositions
  "ya": [
    { original: "Ndako ya mama", french: "La maison de maman", english: "Mom's house" },
    { original: "Mbongo ya tata", french: "L'argent de papa", english: "Dad's money" },
    { original: "Talo ya ndako", french: "Le prix de la maison", english: "The price of the house" }
  ],
  "mpo_na": [
    { original: "Mpo na yo", french: "Pour toi", english: "For you" },
    { original: "Nazali kosala mpo na bino", french: "Je travaille pour vous", english: "I work for you" },
    { original: "Oyo ezali mpo na nini?", french: "Ceci est pour quoi?", english: "What is this for?" }
  ],
  "kati_na": [
    { original: "Kati na ndako", french: "À l'intérieur de la maison", english: "Inside the house" },
    { original: "Ye azali kati na mpepo", french: "Il est dans l'avion", english: "He is in the plane" },
    { original: "Bilei ezali kati na ndeko", french: "La nourriture est dans le sac", english: "The food is in the bag" }
  ],
  "liboso_ya": [
    { original: "Liboso ya ndako", french: "Devant la maison", english: "In front of the house" },
    { original: "Liboso ya kosala", french: "Avant de travailler", english: "Before working" },
    { original: "Liboso ya kolala", french: "Avant de dormir", english: "Before sleeping" }
  ],
  "nsima_ya": [
    { original: "Nsima ya ndako", french: "Derrière la maison", english: "Behind the house" },
    { original: "Nsima ya koliya", french: "Après avoir mangé", english: "After eating" },
    { original: "Nsima ya mosala", french: "Après le travail", english: "After work" }
  ],
  "likolo_ya": [
    { original: "Likolo ya mesa", french: "Sur la table", english: "On the table" },
    { original: "Mokanda ezali likolo ya mbeto", french: "Le livre est sur le lit", english: "The book is on the bed" },
    { original: "Mbula ezali likolo ya biso", french: "La pluie est au-dessus de nous", english: "The rain is above us" }
  ],

  // Adjectifs qualificatifs (ajoutez d'autres adjectifs au besoin)
  "monene": [
    { original: "Ndako monene", french: "Grande maison", english: "Big house" },
    { original: "Libota monene", french: "Grande famille", english: "Big family" },
    { original: "Mesa monene", french: "Grande table", english: "Big table" }
  ],
  "moke": [
    { original: "Mwana moke", french: "Petit enfant", english: "Small child" },
    { original: "Ndako moke", french: "Petite maison", english: "Small house" },
    { original: "Mbongo moke", french: "Peu d'argent", english: "Little money" }
  ],
  "malamu": [
    { original: "Bilei malamu", french: "Bonne nourriture", english: "Good food" },
    { original: "Moto malamu", french: "Bonne personne", english: "Good person" },
    { original: "Mbula malamu", french: "Bonne pluie", english: "Good rain" }
  ]


  // Ajoutez d'autres mots et phrases au besoin
};

export default sentencesgap;
